import * as zod from 'zod';

import { RobotiqBaseStateSchema } from '../../shared/types';

export const RobotiqEPickState = RobotiqBaseStateSchema.extend({
  kind: zod.literal('RobotiqEPick'),
  vacuumKPa: zod.number(),
});

export type RobotiqEPickState = zod.infer<typeof RobotiqEPickState>;
